import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getClientHealth } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";

export default function ClientHealthWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [scores, setScores] = useState([]);

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      setScores([
        { clientId: 'demo-a', clientName: 'Demo Ltd', score: 92 },
        { clientId: 'demo-b', clientName: 'Acme Bakery', score: 74 },
        { clientId: 'demo-c', clientName: 'Green Farms', score: 58 },
      ]);
      setLoading(false);
      return;
    }
    if (!tenantId) return;
    setLoading(true);
    getClientHealth(tenantId)
      .then((res) => setScores(res.scores || []))
      .catch(() => setScores([]))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={24} /></VuiBox>;
  if (!scores.length) return <VuiBox p={2}><VuiTypography color="text">No client health data.</VuiTypography></VuiBox>;

  return (
    <VuiBox p={1} display="flex" flexDirection="column" gap={1}>
      {scores.slice(0, 6).map((s) => (
        <VuiBox key={s.clientId} display="flex" justifyContent="space-between" sx={{ p: 1, background: "#fff", borderRadius: 1 }}>
          <VuiTypography sx={{ color: TC.primary }}>{s.clientName || s.clientId}</VuiTypography>
          <VuiTypography sx={{ color: s.score > 70 ? "#4caf50" : s.score > 40 ? "#ff9800" : "#f44336", fontWeight: 700 }}>{s.score}%</VuiTypography>
        </VuiBox>
      ))}
    </VuiBox>
  );
}

